import { Injectable, OnDestroy } from '@angular/core';
import * as _ from 'lodash-es';
import * as Rx from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GridEventService implements OnDestroy {
  listeners: any = {};
  eventsSubject: Rx.Subject<any>;
  events: Rx.Observable<any>;

  constructor() {
    this.eventsSubject = new Rx.Subject();
    this.events = Rx.from(this.eventsSubject);
  }

  ngOnDestroy(): void {
    this.listeners = {};
    if (this.eventsSubject) {
      this.eventsSubject.next(undefined);
      this.eventsSubject.complete();
    }
  }

  on(name: string | number, type: string, listener: any): any {
    this.listeners[name] = this.listeners[name] || [];

    _.remove(this.listeners[name], (item: any) => item.type === type);

    this.listeners[name].push({ type, fn: listener });
    return listener;
  }

  off(name: string | number, listener: any): void {
    if (!this.listeners[name]) return;
    this.listeners[name] = this.listeners[name].filter(
      (x: any) => x.fn != listener
    );
  }

  broadcast(name: any, ...args: any): void {
    this.eventsSubject.next({ name, args });
    if (this.listeners[name]) {
      for (const listener of this.listeners[name]) {
        listener.fn(...args);
      }
    }
  }

  destroy(): void {
    this.listeners = {};
    this.eventsSubject.next(undefined);
    this.eventsSubject.complete();
  }
}
